function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrashServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.74,159a10.46,10.46,0,0,1,1.78,1.54c1.06,1,2.49,2.4,4,4h-.37l.05-.06c1.52-1.63,2.92-3.09,3.95-4.13a10.29,10.29,0,0,1,1.75-1.61,11.43,11.43,0,0,1-1.48,1.86c-1,1.1-2.32,2.6-3.84,4.24l0,.05-.18.2-.2-.19c-1.56-1.58-2.95-3-3.94-4.08A10.85,10.85,0,0,1,124.74,159Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34,164.49s0-.09,0-.27,0-.46,0-.79c0-.72,0-1.76,0-3.09,0-2.73,0-6.68-.07-11.67,0-10,0-24.24-.09-41l.23.23-41.2,0H62.6v-.25c0-20.74.07-38.68.09-51.46,0-6.36.06-11.44.08-15,0-1.73,0-3.07,0-4,0-.44,0-.78,0-1s0-.35,0-.35a1.35,1.35,0,0,1,0,.35c0,.25,0,.59,0,1,0,.93,0,2.27,0,4,0,3.51,0,8.59.07,15,0,12.78.06,30.72.09,51.46l-.25-.25H89.14l41.2,0h.24v.24c0,16.8-.07,31-.09,41,0,5-.05,8.94-.07,11.67,0,1.33,0,2.37,0,3.09,0,.33,0,.6,0,.79A.8.8,0,0,1,130.34,164.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73,243.76c0,.14-17.65.26-39.41.26s-39.42-.12-39.42-.26,17.65-.26,39.42-.26S105.73,243.62,105.73,243.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,249.41a10.63,10.63,0,0,1,1.53-1.78c1-1.06,2.4-2.49,4-4V244l0,0c-1.64-1.52-3.1-2.92-4.14-4a10.29,10.29,0,0,1-1.61-1.75,10.94,10.94,0,0,1,1.86,1.48c1.1,1,2.6,2.32,4.24,3.84l.05,0,.2.18-.19.2c-1.58,1.56-3,3-4.08,3.94A11.08,11.08,0,0,1,100,249.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,307.69a11.13,11.13,0,0,1,1.53-1.78c1-1.05,2.4-2.49,4-4.05v.38l0-.05c-1.64-1.52-3.1-2.92-4.14-3.95a10.75,10.75,0,0,1-1.61-1.75,10.94,10.94,0,0,1,1.86,1.48c1.1,1,2.6,2.32,4.24,3.84l.05.05.2.18-.19.19c-1.58,1.56-3,2.95-4.08,3.94A10.46,10.46,0,0,1,100,307.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.63,369.92l-.39,0-1.12,0-4.32,0-15.88.08-52.41.08H26.9l.26-.26c0,19.17-.06,36.29-.08,48.65,0,6.14-.06,11.1-.08,14.56,0,1.69,0,3-.05,3.94,0,.42,0,.76,0,1a1.6,1.6,0,0,1,0,.35,2.37,2.37,0,0,1,0-.35q0-.39,0-1c0-.93,0-2.25,0-3.94,0-3.46,0-8.42-.08-14.56,0-12.36-.05-29.48-.09-48.65v-.26h5.87l52.41.07,15.88.09,4.32.05,1.12,0A1.93,1.93,0,0,1,106.63,369.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,364.27a11.08,11.08,0,0,1,1.79,1.52c1.06,1,2.51,2.38,4.08,3.94l.19.19-.2.19,0,.05c-1.63,1.52-3.14,2.88-4.24,3.84a10.94,10.94,0,0,1-1.86,1.48,10.29,10.29,0,0,1,1.61-1.75c1-1,2.5-2.43,4.14-4l0,0v.37c-1.57-1.56-3-3-4-4.05A10.63,10.63,0,0,1,100.94,364.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.08,408.83a10.46,10.46,0,0,1,1.79,1.52c1.07,1,2.51,2.38,4.08,3.94l.19.19-.19.19-.06.05c-1.63,1.52-3.13,2.87-4.24,3.83A9.78,9.78,0,0,1,98.79,420a11.66,11.66,0,0,1,1.61-1.74c1-1,2.5-2.43,4.14-4l0,0v.37c-1.58-1.56-3-3-4-4.05A10.46,10.46,0,0,1,99.08,408.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.29,92.53a.84.84,0,0,1,.28,0l.84,0,3.25,0,12.26-.07h.15v.15c0,16.43.06,43.7.11,74.56,0,7.85,0,15.46,0,22.6l-.25-.25,49.11.09,14.32.07,3.84.05,1,0,.33,0a1.19,1.19,0,0,1-.33,0l-1,0-3.84,0L85,189.85l-49.11.09h-.26V167.09c0-30.86.08-58.13.11-74.56l.15.15-12.26-.07-3.25,0-.84,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.29,302.09c0-.14,19.35-.26,43.21-.26s43.23.12,43.23.26-19.35.26-43.23.26S19.29,302.24,19.29,302.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.85,467.36a.67.67,0,0,1,0-.25l0-.71c0-.68,0-1.6,0-2.77,0-2.44,0-5.9-.08-10.16,0-8.62-.05-20.46-.08-33.53v-5.77h.26l29.82.09,8.87.08,2.4,0a5.43,5.43,0,0,1,.83.05,5.43,5.43,0,0,1-.83.05l-2.4,0-8.87.07-29.82.09.26-.26v5.51c0,13.07,0,24.91-.07,33.53,0,4.26-.07,7.72-.09,10.16,0,1.17,0,2.09,0,2.77l0,.71A.79.79,0,0,1,62.85,467.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.83,195.41a10.63,10.63,0,0,1,1.53-1.78c1-1.06,2.4-2.49,4-4V190l-.06,0c-1.63-1.52-3.09-2.92-4.13-4a10.29,10.29,0,0,1-1.61-1.75,10.94,10.94,0,0,1,1.86,1.48c1.1,1,2.6,2.32,4.24,3.84l0,0,.2.18-.19.2c-1.58,1.56-3,3-4.08,3.94A11.08,11.08,0,0,1,98.83,195.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,159.06a10.46,10.46,0,0,1-1.52,1.79c-1,1.07-2.38,2.51-3.94,4.08l-.19.19-.19-.19-.05-.06c-1.52-1.63-2.87-3.13-3.84-4.24a9.94,9.94,0,0,1-1.47-1.86,11,11,0,0,1,1.74,1.61c1,1,2.43,2.5,3.95,4.14l.05,0h-.37c1.56-1.58,3-3,4.05-4A10.46,10.46,0,0,1,373,159.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,164.52a1.39,1.39,0,0,1,0-.27c0-.19,0-.45,0-.79,0-.71,0-1.74,0-3.07,0-2.7,0-6.63-.06-11.61,0-10-.06-24.21-.09-41.13v-.23h.23l47.09,0h20.4l-.26.25c0-23.82.07-44.7.09-59.66,0-7.45.06-13.42.08-17.55,0-2,0-3.62,0-4.72,0-.52,0-.92,0-1.22a3.24,3.24,0,0,1,0-.41,3.24,3.24,0,0,1,0,.41c0,.3,0,.7,0,1.22,0,1.1,0,2.68,0,4.72,0,4.13,0,10.1.08,17.55,0,15,.05,35.84.08,59.66v.26H414.44l-47.09,0,.23-.23c0,16.92-.07,31.13-.09,41.13,0,5-.05,8.91-.07,11.61,0,1.33,0,2.36,0,3.07,0,.34,0,.6,0,.79S367.35,164.52,367.35,164.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,243.79c0-.15,19.15-.26,42.76-.26s42.77.11,42.77.26-19.14.26-42.77.26S392,243.93,392,243.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.66,249.43a9.34,9.34,0,0,1-1.8-1.52c-1.06-1-2.5-2.38-4.08-3.94l-.19-.19.2-.18,0,0c1.64-1.52,3.14-2.88,4.24-3.84a11.43,11.43,0,0,1,1.86-1.48,10.75,10.75,0,0,1-1.61,1.75c-1,1-2.5,2.43-4.13,4l-.06,0v-.38c1.57,1.56,3,3,4,4.05A10.94,10.94,0,0,1,397.66,249.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.66,307.72a9.84,9.84,0,0,1-1.8-1.52c-1.06-1-2.5-2.38-4.08-3.94l-.19-.19.2-.19,0-.05c1.64-1.52,3.14-2.87,4.24-3.84a10.33,10.33,0,0,1,1.86-1.47,11,11,0,0,1-1.61,1.74c-1,1-2.5,2.43-4.13,3.95l-.06.05v-.37c1.57,1.56,3,3,4,4.05A10.46,10.46,0,0,1,397.66,307.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.07,369.94l.35,0,1,0,4,0,14.92-.08,50.37-.08H462v.25c0,3.79,0,7.76,0,11.8,0,22-.06,42-.08,56.72l-.18-.19,18.86.09,5.13.05,1.34,0,.45,0a2.56,2.56,0,0,1-.45,0l-1.34,0-5.13.05-18.86.08h-.19v-.19c0-14.7,0-34.7-.07-56.72v-11.8l.26.26-50.37-.08L396.49,370l-4-.05-1,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.75,364.3a10.5,10.5,0,0,1-1.53,1.78c-1,1.05-2.4,2.49-4,4.05v-.38l.06.05c1.63,1.52,3.09,2.92,4.13,3.95A11.27,11.27,0,0,1,397,375.5a10.16,10.16,0,0,1-1.86-1.48c-1.1-1-2.6-2.31-4.24-3.84l-.05,0-.2-.19.19-.19c1.58-1.56,3-2.95,4.08-3.94A10.46,10.46,0,0,1,396.75,364.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.61,408.85a10.42,10.42,0,0,1-1.53,1.79c-1,1.05-2.4,2.48-4,4.05v-.38l0,.05c1.64,1.52,3.1,2.92,4.14,3.95a10.75,10.75,0,0,1,1.61,1.75,10.94,10.94,0,0,1-1.86-1.48c-1.11-1-2.61-2.32-4.24-3.84l-.05-.05-.2-.18.19-.19c1.57-1.56,3-3,4.08-3.94A10.89,10.89,0,0,1,398.61,408.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.56,92.55l-.45,0-1.32,0-5.09.05-18.92.08.17-.18c0,17.31.05,42.27.09,70,0,9.51,0,18.69,0,27.18V190h-.25l-49.21-.1-14.26-.07-3.82,0-1,0-.33,0a1.19,1.19,0,0,1,.33,0l1,0,3.82,0,14.26-.07,49.21-.09-.25.25c0-8.49,0-17.67,0-27.18,0-27.72.06-52.68.08-70v-.18h.18l18.92.08,5.09,0,1.32,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.56,302.12c0,.14-21.4.26-47.79.26s-47.8-.12-47.8-.26,21.39-.26,47.8-.26S487.56,302,487.56,302.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.84,467.39a.87.87,0,0,1,0-.25c0-.19,0-.43,0-.72,0-.67,0-1.59-.05-2.76,0-2.45-.05-5.91-.08-10.16,0-8.62-.05-20.46-.08-33.53v-5.51l.26.26L405,414.63l-8.87-.08-2.4,0a7.83,7.83,0,0,1-.83-.05,4.16,4.16,0,0,1,.83,0l2.4-.05,8.87-.08,29.82-.08h.26V420c0,13.07-.06,24.91-.08,33.53,0,4.25-.06,7.71-.08,10.16,0,1.17,0,2.09-.05,2.76,0,.29,0,.53,0,.72A.87.87,0,0,1,434.84,467.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.87,195.43a10.25,10.25,0,0,1-1.8-1.52c-1.06-1-2.5-2.38-4.08-3.94l-.19-.19.2-.18.05,0c1.64-1.52,3.14-2.88,4.24-3.84a11.43,11.43,0,0,1,1.86-1.48,10.75,10.75,0,0,1-1.61,1.75c-1,1-2.5,2.43-4.13,4l-.05,0v-.38c1.57,1.56,3,3,4,4.05A10.94,10.94,0,0,1,398.87,195.43Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.53,262a54.26,54.26,0,0,0,2.2,6.49,52.17,52.17,0,0,0,3.44,5.92A6.69,6.69,0,0,1,89.8,273a22.38,22.38,0,0,1-4-8.89A6.44,6.44,0,0,1,85.53,262Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.59,262.42a66.61,66.61,0,0,0,2.9,6.52,70.39,70.39,0,0,0,4,5.91A7.64,7.64,0,0,1,89,273.37a25.86,25.86,0,0,1-2.9-4.2,25.07,25.07,0,0,1-2-4.69A7.85,7.85,0,0,1,83.59,262.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31,264.31c.15,0,.18,2,.87,4.43s1.71,4.15,1.59,4.22a12.28,12.28,0,0,1-2.46-8.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,340.16a29.77,29.77,0,0,0,2.2,5,32.6,32.6,0,0,0,3.43,4.21,10.73,10.73,0,0,1-3.84-3.95A10.61,10.61,0,0,1,101,340.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,340.42a43.87,43.87,0,0,1,2,5,48.65,48.65,0,0,1,1.83,5.08,35.21,35.21,0,0,1-3.78-10.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85,311.94l-1.17,4.47a9.91,9.91,0,0,0-10.28,3.38A8.51,8.51,0,0,1,118,324.7a7.25,7.25,0,0,1-.38,6.14,6.4,6.4,0,0,1-4.37,3.36,7.26,7.26,0,0,1-7.42-3.58,9.08,9.08,0,0,1-1.15-3.39l-.27.34a12.38,12.38,0,0,0-.37,13.94l-3.82,2.6a16.93,16.93,0,0,1,.52-19.35,13.72,13.72,0,0,1,4.83-4,14.59,14.59,0,0,1,17.3-8.8Zm-13.68,13.77a5,5,0,0,0,.62,2.55,2.71,2.71,0,0,0,2.55,1.41,1.94,1.94,0,0,0,1.19-1,2.7,2.7,0,0,0,.18-2.19,4.16,4.16,0,0,0-4.23-2.14l-.18,0A7.26,7.26,0,0,0,109.17,325.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.62,285.88c-13,1.63-28.11-2.62-35.38-13l2-2.46s7.66,12.86,33.48,11.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47,274a13.18,13.18,0,0,1-2.26,2.46A13.18,13.18,0,0,1,93.47,274Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.47,276.35a6.9,6.9,0,0,1-1,1.4A7.52,7.52,0,0,1,94.35,279a7,7,0,0,1,1-1.41A6.78,6.78,0,0,1,96.47,276.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,278.21a6.32,6.32,0,0,1-.8,1.62,6,6,0,0,1-1.08,1.44,11.5,11.5,0,0,1,.9-1.55A11.33,11.33,0,0,1,100.13,278.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,283.19a8.9,8.9,0,0,1,.69-1.77,8.43,8.43,0,0,1,.89-1.69,8.85,8.85,0,0,1-.7,1.77A9,9,0,0,1,102,283.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,284.37a7.85,7.85,0,0,1,.59-1.77,8.93,8.93,0,0,1,.78-1.7,8,8,0,0,1-.59,1.77A8.24,8.24,0,0,1,106,284.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,285.25a9.12,9.12,0,0,1,.35-1.88,8.4,8.4,0,0,1,.55-1.83,9.35,9.35,0,0,1-.35,1.88A8.21,8.21,0,0,1,109.76,285.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,285.8a8.5,8.5,0,0,1,.21-1.87,9.43,9.43,0,0,1,.42-1.83,16.53,16.53,0,0,1-.63,3.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.12,286a15.25,15.25,0,0,1,.22-1.8c.13-1,.16-1.79.22-1.79a5,5,0,0,1,0,1.82A5.34,5.34,0,0,1,117.12,286Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8,339.34a13,13,0,0,1-2.07.94,13.87,13.87,0,0,1-2.16.75,11.53,11.53,0,0,1,2.08-.94A12.47,12.47,0,0,1,102.8,339.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,336.53a12.59,12.59,0,0,1-2.25.5,11.66,11.66,0,0,1-2.28.3,13.43,13.43,0,0,1,2.24-.5A12.71,12.71,0,0,1,102.14,336.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.17,333.47a12.57,12.57,0,0,1-2.3,0,12.42,12.42,0,0,1-2.3-.18,12.77,12.77,0,0,1,2.31,0A13.49,13.49,0,0,1,102.17,333.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,330.82a12,12,0,0,1-2.06-.77,11.81,11.81,0,0,1-2-1,11.94,11.94,0,0,1,2.06.78A11.84,11.84,0,0,1,102.6,330.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.13,327.4a5.85,5.85,0,0,1-1.74-1.12,6.24,6.24,0,0,1-1.41-1.52s.68.63,1.54,1.36S104.16,327.35,104.13,327.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.74,327.84a5,5,0,0,1-.09-1,16.88,16.88,0,0,1,.13-2.5,16.22,16.22,0,0,1,.47-2.45,4.57,4.57,0,0,1,.33-1,6.26,6.26,0,0,1-.19,1c-.13.62-.29,1.49-.41,2.45s-.16,1.84-.18,2.47A5.91,5.91,0,0,1,104.74,327.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,319.37a14.75,14.75,0,0,0-1.69,2.48,15.79,15.79,0,0,0-1,2.84,2.61,2.61,0,0,1,.08-.89,8.35,8.35,0,0,1,1.92-3.83A2.75,2.75,0,0,1,111.91,319.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.89,323.44a2.19,2.19,0,0,1-.51-.78,2,2,0,0,1-.33-.87,4.31,4.31,0,0,1,.84,1.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,328.29c0,.06-1,.26-2.11.77s-1.93,1.1-2,1.05a5.37,5.37,0,0,1,1.89-1.24A5.58,5.58,0,0,1,109.74,328.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.82,333.54a26.77,26.77,0,0,1,2.28-4.1,13.16,13.16,0,0,1-1,2.1A12.82,12.82,0,0,1,108.82,333.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,334a21.51,21.51,0,0,1-.51-2.24c-.27-1.24-.53-2.23-.48-2.25a8.78,8.78,0,0,1,.68,2.2A9.23,9.23,0,0,1,113.7,334Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,329.47a11.92,11.92,0,0,1-2.13-.64,11.56,11.56,0,0,1-2.07-.83,12.15,12.15,0,0,1,2.14.64A10.89,10.89,0,0,1,118.07,329.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,324.31c0,.06-1,.34-2.16.81s-2.11.92-2.14.87a11.07,11.07,0,0,1,4.3-1.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.48,320.32c.06,0-.49.93-1,2.09s-.88,2.16-.94,2.14a7.85,7.85,0,0,1,.75-2.22A7.6,7.6,0,0,1,113.48,320.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,324.74c0,.06-.91.09-2,.23s-2,.34-2,.28a6.38,6.38,0,0,1,2-.48A6,6,0,0,1,109,324.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,321.28c0,.06-1-.16-2.25-.27s-2.25-.07-2.25-.14a6.85,6.85,0,0,1,2.27-.07A7,7,0,0,1,110.21,321.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.12,318.24c0,.06-1-.52-2.38-1s-2.5-.62-2.49-.68a2.21,2.21,0,0,1,.76.05,9.64,9.64,0,0,1,1.79.43,10.81,10.81,0,0,1,1.69.75A2.78,2.78,0,0,1,113.12,318.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.49,316.84c-.06,0-.36-1-1-2.08s-1.31-1.88-1.26-1.92a5.88,5.88,0,0,1,1.44,1.82A5.67,5.67,0,0,1,115.49,316.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.67,311.51a6.18,6.18,0,0,1,.49,4.59,11.39,11.39,0,0,0-.49-4.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.6,269.43a31.44,31.44,0,0,0-2.21-5,30.77,30.77,0,0,0-3.43-4.21,12.71,12.71,0,0,1,5.64,9.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.75,269.18a50.75,50.75,0,0,1-1.95-5,46.27,46.27,0,0,1-1.82-5.08,23.09,23.09,0,0,1,2.27,4.91A22.8,22.8,0,0,1,395.75,269.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.77,297.65l1.17-4.47a10.2,10.2,0,0,0,7.83-1.2,9.79,9.79,0,0,0,2.45-2.18,8.51,8.51,0,0,1-6.59-4.91,7.25,7.25,0,0,1,.39-6.14,6.4,6.4,0,0,1,4.37-3.36A7.24,7.24,0,0,1,389.8,279a9.27,9.27,0,0,1,1.16,3.39l.26-.34a12.37,12.37,0,0,0,.38-13.94l3.82-2.6a17,17,0,0,1-.53,19.35,13.58,13.58,0,0,1-4.82,4,14.61,14.61,0,0,1-17.3,8.8Zm13.67-13.77a5,5,0,0,0-.62-2.55,2.66,2.66,0,0,0-2.54-1.4,1.87,1.87,0,0,0-1.19,1,2.7,2.7,0,0,0-.19,2.19,4.16,4.16,0,0,0,4.24,2.14l.18,0A8.17,8.17,0,0,0,386.44,283.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.82,270.25a12.53,12.53,0,0,1,2.07-.94,12.19,12.19,0,0,1,2.15-.74,12.54,12.54,0,0,1-2.07.93A12.79,12.79,0,0,1,392.82,270.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.48,273.06a12.59,12.59,0,0,1,2.25-.5,11.66,11.66,0,0,1,2.28-.3,13.72,13.72,0,0,1-2.25.5A12.65,12.65,0,0,1,393.48,273.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.45,276.12a12.46,12.46,0,0,1,2.3,0,13.21,13.21,0,0,1,2.29.18,12.57,12.57,0,0,1-2.3,0A12.37,12.37,0,0,1,393.45,276.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,278.77a22.33,22.33,0,0,1,4,1.74,12.85,12.85,0,0,1-2.05-.77A11.81,11.81,0,0,1,393,278.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.49,282.19a6.26,6.26,0,0,1,1.74,1.12,6.07,6.07,0,0,1,1.4,1.52s-.67-.63-1.54-1.36S391.46,282.25,391.49,282.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,281.75a3.94,3.94,0,0,1,.1,1,18.37,18.37,0,0,1-.13,2.5,18.05,18.05,0,0,1-.47,2.46,4.25,4.25,0,0,1-.34,1,9.61,9.61,0,0,1,.2-1c.13-.62.29-1.48.4-2.45s.17-1.83.19-2.47A6.79,6.79,0,0,1,390.87,281.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,290.23a14.94,14.94,0,0,0,1.69-2.49,15.13,15.13,0,0,0,1-2.84,2.82,2.82,0,0,1-.09.89,8,8,0,0,1-1.92,3.83A3,3,0,0,1,383.7,290.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.73,286.15a4.31,4.31,0,0,1,.84,1.65c-.05,0-.28-.32-.52-.78S390.67,286.18,390.73,286.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.88,281.3c0-.06,1-.26,2.1-.77s1.94-1.1,2-1a6.9,6.9,0,0,1-4.08,1.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8,276.05a13.16,13.16,0,0,1-1.05,2.1,14.13,14.13,0,0,1-1.23,2,13.16,13.16,0,0,1,1.05-2.1A12.82,12.82,0,0,1,386.8,276.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.92,275.6a21.51,21.51,0,0,1,.51,2.24,19.9,19.9,0,0,1,.47,2.25,9.87,9.87,0,0,1-.68-2.2A8.92,8.92,0,0,1,381.92,275.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.55,280.12a12.19,12.19,0,0,1,2.13.64,11.26,11.26,0,0,1,2.06.83,12.47,12.47,0,0,1-2.13-.64A10.55,10.55,0,0,1,377.55,280.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.82,285.28c0-.06,1-.34,2.16-.81s2.11-.92,2.14-.87a7.7,7.7,0,0,1-2.06,1.07A7.92,7.92,0,0,1,377.82,285.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,289.27c-.05,0,.49-.93,1-2.09s.88-2.16.94-2.14a8,8,0,0,1-.75,2.23A7.51,7.51,0,0,1,382.13,289.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.6,284.85c0-.06.91-.09,2-.23s2-.34,2-.28a6.49,6.49,0,0,1-2,.48A6.05,6.05,0,0,1,386.6,284.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,288.31c0-.06,1,.17,2.24.27s2.25.07,2.26.14a7,7,0,0,1-2.28.07A6.76,6.76,0,0,1,385.41,288.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5,291.35c0-.06,1,.52,2.38,1s2.49.62,2.48.68a2.33,2.33,0,0,1-.76,0,10.31,10.31,0,0,1-3.47-1.19A2.22,2.22,0,0,1,382.5,291.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.12,292.75c.07,0,.37,1,1,2.08s1.32,1.88,1.27,1.92a7.37,7.37,0,0,1-2.26-4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,298.08a5,5,0,0,1-.69-2.25,5.18,5.18,0,0,1,.19-2.34,21.66,21.66,0,0,0,0,2.32A20,20,0,0,0,377,298.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.61,
    y: 219.02,
    width: 12.79,
    height: 5.78,
    transform: "translate(-54.31 279.22) rotate(-36.52)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.14,223.39a13.73,13.73,0,0,1,1.06,1.24c.63.79,1.52,1.9,2.57,3.27l-.32,0c2.62-2,6.23-4.73,10.22-7.69.06-.4-.08.55-.06.45h0l0,0,0,0-.05-.07-.12-.15-.22-.31-.45-.6-.87-1.19L399.18,216l.42.07c-3,2.16-5.52,4-7.38,5.29-.87.59-1.6,1.1-2.21,1.53a5.93,5.93,0,0,1-.87.54,4,4,0,0,1,.67-.58l2.05-1.63c1.78-1.39,4.35-3.37,7.38-5.64l.24-.18.19.24c.54.72,1.1,1.47,1.67,2.25.29.39.59.78.88,1.18l.45.6.23.31.11.15.06.07,0,0,0,0h0c0-.1-.12.85-.07.45-4,2.95-7.64,5.61-10.33,7.54l-.19.13-.13-.18c-1.07-1.5-1.9-2.71-2.46-3.53A8.89,8.89,0,0,1,389.14,223.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.31,214.77a5.33,5.33,0,0,0-7.46-1.12l6.35,8.58A5.32,5.32,0,0,0,405.31,214.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.31,214.77s.18.13.42.47a4.91,4.91,0,0,1,.7,1.62,5.29,5.29,0,0,1-.08,2.72,5.44,5.44,0,0,1-2,2.89l-.23.18-.18-.24-3.19-4.28c-1.12-1.51-2.18-3-3.16-4.3l-.18-.24.24-.17a5.56,5.56,0,0,1,3.34-1.06,5.38,5.38,0,0,1,2.63.73,5.2,5.2,0,0,1,1.35,1.14c.24.33.35.52.32.54a9.86,9.86,0,0,0-1.84-1.36,5.22,5.22,0,0,0-5.45.48l.06-.41,3.2,4.27c1.11,1.52,2.17,3,3.16,4.31L404,222a5.25,5.25,0,0,0,2.06-5.07A9.93,9.93,0,0,0,405.31,214.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,217.51a3.38,3.38,0,0,0,.69-3.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,214c.14-.1.71.76.48,1.92s-1.07,1.75-1.17,1.6.37-.78.54-1.72S404.5,214.06,404.67,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,216.72c.16-.09.91,1,1.93,2.34s1.9,2.33,1.78,2.46-1.24-.71-2.29-2.07S397.58,216.8,397.73,216.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,217.61c.16-.08.92,1,1.93,2.34s1.9,2.33,1.78,2.46-1.24-.71-2.28-2.07S396.37,217.69,396.52,217.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,218.51c.16-.09.92,1,1.93,2.34s1.91,2.32,1.78,2.46-1.23-.71-2.28-2.07S395.16,218.58,395.31,218.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.11,219.4c.16-.09.91,1,1.93,2.34s1.9,2.33,1.78,2.46-1.24-.71-2.29-2.07S394,219.48,394.11,219.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.9,220.29c.16-.08.92,1,1.93,2.34s1.9,2.33,1.78,2.46-1.24-.71-2.28-2.06S392.75,220.37,392.9,220.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.69,221.19c.16-.09.92,1,1.93,2.34s1.91,2.32,1.78,2.46-1.24-.71-2.28-2.07S391.54,221.26,391.69,221.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,222.08c.16-.09.91,1,1.93,2.34s1.9,2.33,1.78,2.46-1.24-.71-2.29-2.07S390.33,222.16,390.49,222.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.44,
    y: 314.8,
    width: 12.79,
    height: 5.78,
    transform: "translate(-204.16 144.73) rotate(-45.18)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.39,315.2a15,15,0,0,1-1.23-1.07c-.74-.68-1.79-1.65-3-2.85h.33c-2.29,2.39-5.45,5.61-9,9.14V320h0l0,0,0,0,.07.07.14.13.26.27.54.53,1,1,2,2h-.43c2.59-2.59,4.86-4.77,6.51-6.35l2-1.84a5.59,5.59,0,0,1,.77-.67s-.17.23-.57.68L76,317.79c-1.55,1.64-3.79,4-6.45,6.69l-.21.22-.22-.22-2-2-1-1-.54-.53-.26-.26-.14-.14-.07-.06,0,0,0,0h0c0,.1,0-.86,0-.45,3.5-3.53,6.7-6.71,9.07-9l.17-.17.16.16c1.28,1.32,2.29,2.4,3,3.13A7.88,7.88,0,0,1,78.39,315.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.71,326.16a5.33,5.33,0,0,0,7.54,0l-7.57-7.53A5.33,5.33,0,0,0,63.71,326.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.71,326.16s-.2-.11-.49-.4a5.13,5.13,0,0,1-.93-1.5,5.34,5.34,0,0,1-.34-2.71,5.56,5.56,0,0,1,1.52-3.15l.2-.21.22.21,3.8,3.75,3.77,3.78.21.21-.21.2a5.53,5.53,0,0,1-3.14,1.55,5.35,5.35,0,0,1-2.71-.33,4.94,4.94,0,0,1-1.5-.92c-.29-.28-.43-.46-.4-.48a10.1,10.1,0,0,0,2,1.07,5.26,5.26,0,0,0,2.52.17,5.18,5.18,0,0,0,2.8-1.47v.41l-3.81-3.74-3.77-3.78h.42a5.13,5.13,0,0,0-1.45,2.81,5.34,5.34,0,0,0,.18,2.51A9.46,9.46,0,0,0,63.71,326.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,323.24a3.35,3.35,0,0,0-.15,3.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,326.83c-.12.12-.82-.64-.76-1.83s.79-1.88.91-1.76-.25.83-.28,1.79S64.62,326.73,64.46,326.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.91,323.09c-.15.11-1.06-.89-2.26-2s-2.23-2-2.13-2.16a5.76,5.76,0,0,1,2.57,1.7C70.33,321.78,71.05,323,70.91,323.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,322c-.15.11-1.06-.88-2.26-2s-2.24-2-2.13-2.17,1.33.52,2.57,1.71S72.11,321.92,72,322Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,321c-.15.11-1.07-.89-2.26-2s-2.24-2-2.13-2.16,1.33.51,2.57,1.7S73.17,320.86,73,321Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09,319.89c-.15.11-1.07-.88-2.27-2s-2.23-2-2.13-2.17,1.34.52,2.57,1.71A5.73,5.73,0,0,1,74.09,319.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.14,318.83c-.14.11-1.06-.89-2.26-2s-2.23-2-2.13-2.16,1.33.51,2.57,1.7S75.28,318.73,75.14,318.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2,317.76c-.14.11-1.06-.89-2.26-2s-2.23-2-2.13-2.17a5.76,5.76,0,0,1,2.57,1.7C75.62,316.46,76.34,317.66,76.2,317.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,316.7c-.14.11-1.06-.89-2.26-2s-2.23-2-2.13-2.16,1.33.51,2.57,1.7S77.4,316.6,77.26,316.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.88,149.61a14.21,14.21,0,0,1-8.59-23.05l52.06-63.22a14.08,14.08,0,0,1,13.3-5h.05a14.07,14.07,0,0,1,10.92,9l28.72,76.7a14.21,14.21,0,0,1-15.64,19l-80.78-13.48Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.88,149.61a14.21,14.21,0,0,1-8.59-23.05l52.06-63.22a14.08,14.08,0,0,1,13.3-5h.05a14.07,14.07,0,0,1,10.92,9l28.72,76.7a14.21,14.21,0,0,1-15.64,19l-80.78-13.48Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.88,149.61l.85.11,2.51.39,9.64,1.56,35.42,5.83,24.46,4,6.71,1.11a20.72,20.72,0,0,0,3.42.4,13.35,13.35,0,0,0,3.44-.38,14.06,14.06,0,0,0,10.05-9.42,13.69,13.69,0,0,0,.25-7.38,31.74,31.74,0,0,0-1.24-3.63c-.46-1.22-.91-2.44-1.37-3.67q-2.77-7.37-5.64-15c-3.83-10.21-7.79-20.78-11.84-31.61q-3-8.12-6-16c-1-2.64-2-5.25-2.94-7.85A13.93,13.93,0,0,0,340,62a26.79,26.79,0,0,0-2.56,2.85q-2.44,3-4.84,5.87l-33.89,41.07c-4.8,5.86-9.23,11.11-13,15.79a13.91,13.91,0,0,0-2.57,7.77,14.34,14.34,0,0,0,1.57,6.75,14.12,14.12,0,0,0,3.43,4.37,14.34,14.34,0,0,0,3.48,2.16,15.58,15.58,0,0,0,2.4.81c.55.12.84.2.84.2s-.29,0-.86-.15a13.9,13.9,0,0,1-9.47-7.3,14.49,14.49,0,0,1-1.64-6.84,14.15,14.15,0,0,1,2.58-7.94c3.75-4.73,8.15-10,12.94-15.85l33.8-41.14,4.84-5.88a25.22,25.22,0,0,1,2.6-2.9A14.39,14.39,0,0,1,343,59.38a14.46,14.46,0,0,1,20.12,8.48c1,2.6,2,5.21,2.94,7.85,2,5.27,4,10.63,6,16,4.06,10.83,8,21.4,11.84,31.62q2.86,7.65,5.62,15l1.37,3.66a33.4,33.4,0,0,1,1.26,3.69,14.24,14.24,0,0,1-.27,7.64,14.57,14.57,0,0,1-10.4,9.73,14.28,14.28,0,0,1-3.56.38,21.07,21.07,0,0,1-3.49-.41l-6.7-1.12-24.45-4.11-35.39-6-9.62-1.65-2.5-.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,62.55h0A9.85,9.85,0,0,0,341.62,66l-52.06,63.22a10,10,0,0,0,6,16.16h0L376.4,158.9a10,10,0,0,0,11-13.33L358.65,68.88A9.87,9.87,0,0,0,351,62.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.3,132.81a5.24,5.24,0,0,1,6.26-4.27,5.25,5.25,0,1,1-1.69,10.37A5.29,5.29,0,0,1,333.3,132.81Zm7.31-42,9.91,1.62-6.77,31.05-6.63-1.08Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.5 155.05 319.05 196.85 337.12 196.85 344.54 157.89 327.5 155.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.2,
    y: 410.58,
    width: 196.1,
    height: 43.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.17,
    y: 454.45,
    width: 258.95,
    height: 10.34,
    rx: 4.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.3,
    y: 178.07,
    width: 252.26,
    height: 232.51,
    rx: 3.38,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.46,
    y: 195.14,
    width: 224.13,
    height: 204.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.01,
    y: 270.18,
    width: 208.16,
    height: 51.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.26,
    y: 280.82,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.26,
    y: 291.67,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.26,
    y: 302.89,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.45,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,207.45,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,284.63a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,217.83,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.2,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,228.2,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,284.63a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,238.58,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,284.63a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,319,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,284.63a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,329.56,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,249,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,299.9,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.33,284.63a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,259.33,284.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,269.7,284.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,290.75,284.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.16,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,338.16,284.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.08,284.63a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,280.08,284.63Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.54,284.63a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,310.54,284.63Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.46,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,333.46,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.09,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,323.09,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.71,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,312.71,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,302.34,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.94,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,221.94,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,211.36,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,292,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,241,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.59,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,281.59,296Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.21,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,271.21,296Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,250.16,296Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.75,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,202.75,296Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83,296a2.36,2.36,0,1,1,2.36,2.35A2.36,2.36,0,0,1,260.83,296Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.13,296a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,231.13,296Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.45,306a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,207.45,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.47,
    cy: 306.04,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.85,
    cy: 306.04,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,306a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,238.58,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.62,
    cy: 306.04,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.2,
    cy: 306.04,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,306a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,249,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,306a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,299.9,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.98,
    cy: 306.04,
    r: 2.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,306a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,269.7,306Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,306a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,290.75,306Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.16,306a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,338.16,306Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.08,306a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,280.08,306Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.43,
    cy: 306.04,
    r: 2.35,
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.01,
    y: 333.91,
    width: 208.16,
    height: 51.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.93,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,206.93,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.31,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,217.31,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,227.68,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,238.06,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.46,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,318.46,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,329,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.44,347.85a2.36,2.36,0,1,1-2.36-2.36A2.36,2.36,0,0,1,248.44,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,299.39,347.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.81,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,258.81,347.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.19,347.85a2.36,2.36,0,1,1-2.35-2.36A2.36,2.36,0,0,1,269.19,347.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,347.85a2.36,2.36,0,1,1-2.35-2.36A2.36,2.36,0,0,1,290.24,347.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.65,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,337.65,347.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,279.56,347.85Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,347.85a2.35,2.35,0,1,1-2.35-2.36A2.35,2.35,0,0,1,309.27,347.85Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,333,359.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.92,
    cy: 359.18,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,312.2,359.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.82,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,301.82,359.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,221.42,359.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.84,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,210.84,359.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.8,
    cy: 359.18,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.49,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,240.49,359.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,281.07,359.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.69,359.18a2.36,2.36,0,1,1,2.36,2.35A2.36,2.36,0,0,1,270.69,359.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 359.18,
    r: 2.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.23,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,202.23,359.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,260.32,359.18Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,359.18a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,230.61,359.18Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.93,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,206.93,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.31,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,217.31,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,227.68,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,238.06,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.46,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,318.46,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,329,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.44,369.26a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,248.44,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,299.39,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.81,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,258.81,369.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.19,369.26a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,269.19,369.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,369.26a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,290.24,369.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.65,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,337.65,369.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,279.56,369.26Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,369.26a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,309.27,369.26Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.26,
    y: 344.55,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.26,
    y: 355.4,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.26,
    y: 366.62,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.76,
    y: 239.62,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.52,
    y: 206.91,
    width: 208.16,
    height: 51.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.76,
    y: 217.55,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.76,
    y: 228.4,
    width: 40.99,
    height: 6.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,221.36a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,209,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.33,221.36A2.35,2.35,0,1,1,217,219,2.35,2.35,0,0,1,219.33,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.71,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,229.71,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.08,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,240.08,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,320.48,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.06,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,331.06,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,250.46,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,301.41,221.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,260.83,221.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.21,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,271.21,221.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.26,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,292.26,221.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.67,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,339.67,221.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34,221.36A2.35,2.35,0,1,1,280,219,2.35,2.35,0,0,1,282.34,221.36Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,221.36a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,312,221.36Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,232.69a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,335,232.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.59,232.69a2.36,2.36,0,1,1,2.35,2.35A2.35,2.35,0,0,1,324.59,232.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.22,232.69a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,314.22,232.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.84,232.69a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,303.84,232.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.44,232.69a2.36,2.36,0,1,1,2.35,2.35A2.35,2.35,0,0,1,223.44,232.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,232.69a2.36,2.36,0,1,1,2.35,2.35A2.35,2.35,0,0,1,212.86,232.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.47,232.69a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,293.47,232.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.87,
    cy: 232.69,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.09,232.69a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,283.09,232.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.07,
    cy: 232.69,
    r: 2.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,232.69A2.35,2.35,0,1,1,254,235,2.35,2.35,0,0,1,251.67,232.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.25,232.69a2.36,2.36,0,1,1,2.36,2.35A2.36,2.36,0,0,1,204.25,232.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,232.69c0-1.3.29-2.35,1.59-2.35a2.35,2.35,0,1,1,0,4.7C263.39,235,263.1,234,263.1,232.69Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.39,232.69a2.35,2.35,0,1,1,2.35,2.35A2.35,2.35,0,0,1,233.39,232.69Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,242.77a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,209,242.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.33,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,219.33,242.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.71,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,229.71,242.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.73,
    cy: 242.77,
    r: 2.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.48,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,320.48,242.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.06,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,331.06,242.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,250.46,242.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,301.41,242.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,260.83,242.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.21,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,271.21,242.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.91,
    cy: 242.77,
    r: 2.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.67,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,339.67,242.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.58,242.77a2.35,2.35,0,0,1-2.35,2.35c-1.3,0-1.59-1.05-1.59-2.35s.29-2.35,1.59-2.35A2.35,2.35,0,0,1,281.58,242.77Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,242.77a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,312,242.77Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a98.55,98.55,0,0,1,.27,10.32A98.55,98.55,0,0,1,168,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S174,445.29,173.82,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.65,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S179.79,445.29,179.65,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.48,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S185.62,445.29,185.48,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.31,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S191.45,445.29,191.31,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.14,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S197.28,445.29,197.14,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S203.11,445.29,203,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.8,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S208.94,445.29,208.8,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.63,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S214.77,445.29,214.63,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.46,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S220.6,445.29,220.46,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a100.39,100.39,0,0,1,.26,10.32A100.39,100.39,0,0,1,226.29,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.12,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a100.39,100.39,0,0,1,.26,10.32A100.39,100.39,0,0,1,232.12,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a100.39,100.39,0,0,1,.26,10.32A100.39,100.39,0,0,1,238,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.78,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32A100.39,100.39,0,0,1,244,435,100.39,100.39,0,0,1,243.78,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a100.39,100.39,0,0,1,.26,10.32A100.39,100.39,0,0,1,249.61,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.44,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a98.55,98.55,0,0,1,.27,10.32A98.55,98.55,0,0,1,255.44,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,445.29A100.39,100.39,0,0,1,261,435a100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S261.42,445.29,261.28,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.11,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S267.25,445.29,267.11,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.94,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S273.08,445.29,272.94,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S278.91,445.29,278.77,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6,445.29a100.39,100.39,0,0,1-.26-10.32,100.39,100.39,0,0,1,.26-10.32c.14,0,.26,4.62.26,10.32S284.74,445.29,284.6,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.43,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S290.57,445.29,290.43,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.26,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S296.4,445.29,296.26,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.09,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S302.23,445.29,302.09,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32.26,4.62.26,10.32S308.06,445.29,307.92,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32A100.39,100.39,0,0,1,314,435,100.39,100.39,0,0,1,313.75,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.58,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a100.39,100.39,0,0,1,.26,10.32A100.39,100.39,0,0,1,319.58,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.41,445.29c-.14,0-.26-4.62-.26-10.32s.12-10.32.26-10.32a100.39,100.39,0,0,1,.26,10.32A100.39,100.39,0,0,1,325.41,445.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.18,410.58c0,.14-55.11.26-123.07.26S125,410.72,125,410.58s55.1-.26,123.08-.26S371.18,410.43,371.18,410.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,454.45c0,.14-56.22.26-125.56.26s-125.56-.12-125.56-.26,56.21-.26,125.56-.26S374,454.31,374,454.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.22,407.16c0-1.89-.09-88.78-.22-222.41l.22.22-238.77,0h0l.26-.26c0,81.11,0,157.33,0,222.41l-.23-.23,238.8.23-238.8.22h-.22v-.22c0-65.08,0-141.3,0-222.41v-.26h.29l238.77,0h.23v.23C368.31,318.38,368.22,405.27,368.22,407.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,258.39s-.1.12-.31.33l-.95.94c-.87.83-2.12,2-3.71,3.57l-13.68,13.08c-11.55,11-27.48,26.34-45,43.33s-33.23,32.48-44.6,43.72l-13.47,13.3-3.67,3.6-1,.93a3.3,3.3,0,0,1-.35.3s.1-.12.31-.34l.93-1,3.6-3.68,13.35-13.42c11.3-11.29,27-26.82,44.49-43.82S262.44,287,274.05,276l13.8-13,3.77-3.5,1-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.23,249.08s-.08.1-.25.27l-.78.77-3,2.9L266.15,263.7c-9.33,9-22.15,21.57-36.27,35.45s-26.9,26.48-36.23,35.5c-4.67,4.51-8.48,8.13-11.17,10.57-1.34,1.22-2.4,2.15-3.15,2.75a9.53,9.53,0,0,1-.89.63.65.65,0,0,1-.27.1c-.08,0-.06-.08-.06-.07,0,.17.44-.13,1.15-.75s1.76-1.56,3.09-2.81c2.64-2.48,6.4-6.14,11-10.68l36.12-35.61c14.12-13.89,27-26.38,36.38-35.34,4.69-4.48,8.52-8.09,11.17-10.56l3.07-2.84.81-.73A1.28,1.28,0,0,1,281.23,249.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.92,215.13a1.7,1.7,0,0,1-.25.28l-.77.76-3,2.91-11.06,10.68c-9.33,9-22.15,21.56-36.27,35.45s-26.9,26.47-36.23,35.5c-4.67,4.51-8.47,8.12-11.16,10.57-1.35,1.22-2.41,2.15-3.16,2.74a7.77,7.77,0,0,1-.89.64.79.79,0,0,1-.26.1c-.09,0-.06-.08-.06-.07,0,.17.44-.13,1.14-.75s1.77-1.57,3.09-2.81c2.64-2.49,6.41-6.15,11-10.69l36.13-35.6c14.12-13.89,27-26.38,36.37-35.35,4.7-4.48,8.52-8.08,11.18-10.56,1.31-1.21,2.34-2.17,3.07-2.83l.8-.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.68,
    y: 212.8,
    width: 3.5,
    height: 30.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.68,
    y: 343.93,
    width: 3.5,
    height: 30.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33,142.88s.13,0,.34.13a2,2,0,0,1,.74.77,3.14,3.14,0,0,1,.38,1.66,5,5,0,0,1-.7,2.13c-.4.72-1,1.43-1.44,2.23a4.53,4.53,0,0,0-.8,2.72,5.08,5.08,0,0,0,1.48,2.78,33.47,33.47,0,0,1,2.49,2.63,4.14,4.14,0,0,1,.93,3.59,5.24,5.24,0,0,1-2.19,2.67c-.89.63-1.75,1.16-2.45,1.77a4.69,4.69,0,0,0-1.42,2.06,5.1,5.1,0,0,0,.16,3.64,9.47,9.47,0,0,0,.7,1.2s-.11-.07-.28-.24a4.08,4.08,0,0,1-.6-.87,5.19,5.19,0,0,1-.34-3.84,5.39,5.39,0,0,1,.56-1.2,5.87,5.87,0,0,1,.94-1.07,28.26,28.26,0,0,1,2.44-1.84,4.77,4.77,0,0,0,2-2.42,3.62,3.62,0,0,0-.85-3.13c-.71-1-1.66-1.72-2.45-2.61a5.4,5.4,0,0,1-1.58-3.07,4.88,4.88,0,0,1,.9-3c.52-.82,1.08-1.5,1.49-2.19a4.65,4.65,0,0,0,.73-2,3,3,0,0,0-.27-1.54A2.63,2.63,0,0,0,238.33,142.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79,142.88s.14,0,.35.13a2,2,0,0,1,.74.77,3.14,3.14,0,0,1,.37,1.66,4.73,4.73,0,0,1-.7,2.13c-.4.72-1,1.43-1.43,2.23a4.47,4.47,0,0,0-.8,2.72,5,5,0,0,0,1.48,2.78,33.47,33.47,0,0,1,2.49,2.63,4.14,4.14,0,0,1,.93,3.59,5.21,5.21,0,0,1-2.2,2.67c-.88.63-1.74,1.16-2.44,1.77a4.71,4.71,0,0,0-1.43,2.06,5.15,5.15,0,0,0,.17,3.64,9.47,9.47,0,0,0,.7,1.2s-.11-.07-.28-.24a3.75,3.75,0,0,1-.6-.87,5.14,5.14,0,0,1-.34-3.84,5.34,5.34,0,0,1,.55-1.2,6.27,6.27,0,0,1,.94-1.07,30.09,30.09,0,0,1,2.45-1.84,4.8,4.8,0,0,0,2-2.42,3.62,3.62,0,0,0-.85-3.13,35.51,35.51,0,0,0-2.45-2.61,5.4,5.4,0,0,1-1.58-3.07,5,5,0,0,1,.91-3c.52-.82,1.08-1.5,1.49-2.19a4.76,4.76,0,0,0,.72-2,3,3,0,0,0-.26-1.54A2.6,2.6,0,0,0,248.79,142.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,142.88s.13,0,.35.13a2,2,0,0,1,.73.77,3.14,3.14,0,0,1,.38,1.66,4.86,4.86,0,0,1-.7,2.13c-.4.72-.95,1.43-1.44,2.23a4.46,4.46,0,0,0-.79,2.72,5,5,0,0,0,1.48,2.78,35.43,35.43,0,0,1,2.49,2.63,4.14,4.14,0,0,1,.92,3.59,5.24,5.24,0,0,1-2.19,2.67c-.88.63-1.74,1.16-2.44,1.77a4.63,4.63,0,0,0-1.43,2.06,5.1,5.1,0,0,0,.16,3.64,11.29,11.29,0,0,0,.7,1.2s-.11-.07-.28-.24a4.49,4.49,0,0,1-.6-.87,5.15,5.15,0,0,1-.33-3.84,5.34,5.34,0,0,1,.55-1.2,6.27,6.27,0,0,1,.94-1.07,27,27,0,0,1,2.45-1.84,4.8,4.8,0,0,0,2-2.42,3.62,3.62,0,0,0-.85-3.13c-.71-1-1.66-1.72-2.45-2.61a5.4,5.4,0,0,1-1.58-3.07,4.88,4.88,0,0,1,.91-3c.52-.82,1.08-1.5,1.48-2.19a4.65,4.65,0,0,0,.73-2,3,3,0,0,0-.27-1.54A2.63,2.63,0,0,0,259.26,142.88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.21,464.79c0,.15-70.84.26-158.2.26s-158.22-.11-158.22-.26,70.82-.26,158.22-.26S408.21,464.65,408.21,464.79Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrashServer);
export default __webpack_public_path__ + "static/media/crash_server.3a8f36c6a42e0cc989ef41a5c7b82f2b.svg";
export { ForwardRef as ReactComponent };